import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditEventFeaturesComponent } from '../edit-event-features/edit-event-features.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var EventFeaturesComponent = /** @class */ (function () {
    function EventFeaturesComponent(_editDescDialog, _toggleService, businessManagerService, snackBar) {
        this._editDescDialog = _editDescDialog;
        this._toggleService = _toggleService;
        this.businessManagerService = businessManagerService;
        this.snackBar = snackBar;
        this.editModeSet = false;
        this.isFlightDeckAdmin = false;
    }
    EventFeaturesComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _a.isFlightDeckAdmin = _b.sent();
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(EventFeaturesComponent.prototype, "hasContent", {
        get: function () {
            return (this.aviationEvent.isFeatured || this.aviationEvent.isValidated || this.aviationEvent.hasAopaPresence
                || this.aviationEvent.isAopaHosted);
        },
        enumerable: true,
        configurable: true
    });
    EventFeaturesComponent.prototype.openEditEventFeaturesDialog = function () {
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '800px';
        dialogConfig.data = { aviationEvent: this.aviationEvent };
        var DIALOG_REF = this._editDescDialog.open(EditEventFeaturesComponent, dialogConfig);
        this._handleModalClose(DIALOG_REF);
    };
    /**
     * listens for dialog close event. Opens snackbar if necessary
     * @param {MatDialogRef<any>} dialogRef
     * @private
     */
    EventFeaturesComponent.prototype._handleModalClose = function (dialogRef) {
        var _this = this;
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogRef.afterClosed().subscribe(function (success) {
            if (success === null) {
                return;
            }
            if (success) {
                _this.snackBar.open('Event Special Features', 'Updated', {
                    duration: 3000
                });
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return EventFeaturesComponent;
}());
export { EventFeaturesComponent };
